import * as React from 'react';

import './TimelineCircleImages.scss';

import TimelineCircleImage from '../TimelineCircleImage/TimelineCircleImage'

interface ITimelineCircleImagesProps {
    leftImage: any;
    rightImage: any;
    leftClassName: string;
    rightClassName: string;
}

class TimelineCircleImages extends React.PureComponent<ITimelineCircleImagesProps> {
    render() {
        const { leftImage, rightImage, leftClassName, rightClassName } = this.props;

        return (
            <>
                <div className="vertical-timeline-circle-images">
                    <TimelineCircleImage image={leftImage} className={leftClassName} />
                    <TimelineCircleImage image={rightImage} className={rightClassName} />
                </div>
            </>
        );
    }
}

export default TimelineCircleImages;